var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { isValid } from 'date-fns';
import { Inset } from 'syf-component-library/ui/spacing';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateAdditionalContent } from '../../../../redux/userAnswers/userAnswers.slice';
import { clearFormError, updateAdditionalFieldFormError } from '../../../../redux/ui/ui.slice';
import Calendar from '../../../../ui/atoms/Calendar/index';
import { t } from '../../../../strings/i18n/i18n';
import useCalendarBlur from '../../../../hooks/useCalendarBlur';
var AdditionalCalendar = function (_a) {
    var currentQuestionAnswer = _a.currentQuestionAnswer, startDate = _a.startDate, endDate = _a.endDate, excludedDates = _a.excludedDates;
    var dispatch = useDispatch();
    var additionalFieldFormError = useSelector(function (state) { return state; }, shallowEqual).ui.additionalFieldFormError;
    var selectedDate = (currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[1])
        ? new Date(currentQuestionAnswer.answers[1])
        : null;
    var handleChange = function (date) {
        if (!isValid(date)) {
            dispatch(updateAdditionalFieldFormError(t('calendar.validDate')));
            return;
        }
        var currentDate = date;
        if (currentDate < startDate) {
            currentDate = startDate;
        }
        else if (currentDate > endDate) {
            currentDate = endDate;
        }
        dispatch(clearFormError());
        dispatch(updateAdditionalContent({
            currentAnswerId: currentQuestionAnswer.id,
            additionalContent: currentDate.toDateString()
        }));
    };
    var _b = useCalendarBlur(handleChange), handleBlur = _b.handleBlur, handleMouseEnter = _b.handleMouseEnter, handleMouseLeave = _b.handleMouseLeave;
    useEffect(function () {
        dispatch(clearFormError());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers[0]]);
    return (_jsx(Inset, __assign({ bottom: "xxlarge", respondToBreakpoints: ['small', 'medium', 'huge'], onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: _jsx(Calendar, { endDate: endDate, error: additionalFieldFormError, excludedDates: excludedDates, id: "additional-calendar-questionnaire", onBlur: handleBlur, onChange: handleChange, placeholderLabel: t('calendar.placeholder'), required: true, selectedDate: selectedDate, startDate: startDate }) })));
};
export default AdditionalCalendar;
//# sourceMappingURL=AdditionalCalendar.js.map